import { useState, useCallback, useEffect, FC, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactFlagsSelect from 'react-flags-select';
import { RootState, AppDispatch } from '@reducers/index';
import { useDispatch, useSelector } from 'react-redux';
import { axiosDummyInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { ISearchResponse } from '@models/scraperModel/searchModel';
import { Countries2DigitCode } from '@models/commonModel';
import { setCountryCode } from '@reducers/service/serviceSlice';
import { getLocaleValueForFlag } from '@utils/common/language';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

import MyAppList from './myAppList';
import SearchedMyAppsList from './searchedAppsList';

// useNavigate state로 appId, provider_type step2 로 넘기기
const AddMyApp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // 검색 리스트에서 내가 등록한 앱의 다른 표시처리를 위해 불러옴
  const { countryCode } = useSelector(({ serviceManager }: RootState) => serviceManager);
  const countriesArr = Countries2DigitCode.map((item) => item.code);

  // 선택한 앱
  const [selectedAppObj, setSelectedAppObj] = useState<null | ISearchResponse>(null);
  const [searchText, setSearchText] = useState<string>('');
  const [searchDataList, setSearchDataList] = useState(null);

  // 내가 등록한 앱 보여주는 팝업 토글
  const [showPopup, setShowPopup] = useState(false);

  // 로딩화면 처리
  const [isLoading, setIsLoading] = useState(false);

  // // useEffect for initial action
  // useEffect(() => {
  //   if (countryCode === null) {
  //     dispatch(setCountryCode({ countryCode: getLocaleValueForFlag() }));
  //   }
  // }, [countryCode]);

  const onSelectCountry = useCallback(
    (code) => {
      dispatch(setCountryCode({ countryCode: code }));
    },
    [dispatch, setCountryCode]
  );

  // 키워드 + 국가를 통한 검색 버튼 이벤트
  const onClickSearch = useCallback(async () => {
    try {
      setShowPopup(false); // 팝업 끄기
      setIsLoading(true); // 로딩처리
      let reqParams;
      if (!countryCode) {
        reqParams = { term: searchText };
      } else {
        reqParams = {
          term: searchText,
          country: countryCode.toLowerCase(),
        };
      }
      const { data, status } = await axiosScraper.post('/axo/searchMyApps', reqParams);
      if (status === 200) {
        setSearchDataList(data);
      }
    } catch (error) {
      // 로딩끄기
    } finally {
      setIsLoading(false);
    }
  }, [searchText, countryCode]);

  const onChangeSearchText = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchText(value);
  }, []);

  const popupHandler = useCallback(() => {
    setShowPopup((prev) => !prev);
  }, []);

  const onSelectMyAppText = useCallback((appTitle: string) => {
    setSearchText(appTitle);
  }, []);

  const onClickSelectApp = useCallback((appObj: ISearchResponse) => {
    setSelectedAppObj(appObj);
  }, []);

  const onClickNextButton = useCallback(() => {
    if (!!selectedAppObj && !!countryCode) {
      navigate('/appManager/myApps/addCompetitorsApp', {
        state: {
          selectedAppObj: selectedAppObj,
        },
      });
    }
  }, [selectedAppObj, countryCode, navigate]);

  return (
    <>
      <div className="manager">
        <h2 className="manager-tit">Add Apps to Your Workspace</h2>
        <p className="manager-dsc">Please add an explanation about adding an app.</p>
      </div>
      <div className="amanager-search">
        <div className="search-box type-1">
          <label className="active">
            <input
              type="text"
              className="search-ipt"
              placeholder="Searching App Area"
              value={searchText}
              onChange={onChangeSearchText}
            />
          </label>
          {/* myAppList팝업 버튼 */}
          <button
            type="button"
            className={`${showPopup ? 'btn-ico-single del' : 'btn-ico-single del send-history'}`}
            onClick={popupHandler}
          >
            <span className="blind"></span>
          </button>
          {/* 내가 등록한 MyApp 목록 */}
          {showPopup && <MyAppList closeHandler={popupHandler} selectAppTextHandler={onSelectMyAppText} />}
        </div>
        <div className="select-api">
          <ReactFlagsSelect
            selected={countryCode}
            onSelect={onSelectCountry}
            countries={countriesArr}
            searchable={true}
          />
          <button
            type="button"
            className="btn pri"
            disabled={searchText.trim().length > 1 ? false : true}
            onClick={onClickSearch}
          >
            Search
          </button>
        </div>
      </div>
      {/* 로딩화면 처리 */}
      {isLoading && (
        <LoaderComponent height="200px">
          <FadeLoader />
        </LoaderComponent>
      )}
      {/* 앱 검색 결과 리스트 */}
      {!isLoading && !!searchDataList && (
        <SearchedMyAppsList
          appDataList={searchDataList}
          selectedApp={selectedAppObj}
          onClickSelectApp={onClickSelectApp}
        />
      )}
      {/* next 버튼 부분 */}
      <div className="bottom-btn">
        <button
          type="button"
          className="btn pri"
          disabled={selectedAppObj === null ? true : false} // myAppInfo이 있어야 competitorApps 페이지 전환 가능!
          onClick={onClickNextButton}
        >
          NEXT
        </button>
      </div>
    </>
  );
};

export default AddMyApp;
